<script setup lang="ts">
import { computed } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import { currentEmail, signOut } from './auth'

const route = useRoute()
const router = useRouter()
const isPublic = computed(() => route.meta.public === true)
const email = computed(() => (route.name ? currentEmail() : null))

const nav = [
  { to: '/', label: 'Visão geral', name: 'overview' },
  { to: '/alertas', label: 'Alertas', name: 'alerts' },
  { to: '/contas', label: 'Contas', name: 'organizations' },
  { to: '/equipe', label: 'Equipe', name: 'team' },
]

function logout(): void {
  signOut()
  void router.push({ name: 'login' })
}

const isActive = (name: string): boolean =>
  route.name === name || (name === 'organizations' && (route.name === 'organization' || route.name === 'video'))
</script>

<template>
  <RouterView v-if="isPublic" />
  <div v-else class="shell">
    <aside class="side">
      <div class="brand">
        <svg viewBox="0 0 32 32" width="26" height="26" aria-hidden="true"><rect width="32" height="32" rx="8" fill="#00983a" /><path d="M12 9l11 7-11 7z" fill="#fff" /></svg>
        <div>
          <strong>VSL Max</strong>
          <div class="mute" style="font-size: 12px">Backoffice</div>
        </div>
      </div>
      <nav>
        <RouterLink v-for="item in nav" :key="item.to" :to="item.to" :class="{ on: isActive(item.name) }" :data-testid="`nav-${item.name}`">
          {{ item.label }}
        </RouterLink>
      </nav>
      <div class="me">
        <div class="mute" style="font-size: 12px; overflow-wrap: anywhere">{{ email }}</div>
        <button type="button" class="link" data-testid="logout" @click="logout">Sair</button>
      </div>
    </aside>
    <main class="content">
      <RouterView :key="route.fullPath.split('?')[0]" />
    </main>
  </div>
</template>

<style scoped>
.shell { display: grid; grid-template-columns: 220px 1fr; min-height: 100vh; }
.side { background: var(--bg-1); border-right: 1px solid var(--line); padding: 20px 14px; display: flex; flex-direction: column; gap: 24px; position: sticky; top: 0; height: 100vh; }
.brand { display: flex; align-items: center; gap: 10px; padding: 0 6px; }
nav { display: flex; flex-direction: column; gap: 2px; }
nav a { color: var(--text-dim); padding: 8px 10px; border-radius: 8px; }
nav a:hover { background: var(--bg-2); color: var(--text); text-decoration: none; }
nav a.on { background: var(--brand-soft); color: var(--text); }
.me { margin-top: auto; padding: 0 6px; display: flex; flex-direction: column; gap: 6px; align-items: flex-start; }
.content { padding: 28px 32px; min-width: 0; }
@media (max-width: 860px) {
  .shell { grid-template-columns: 1fr; }
  .side { position: static; height: auto; flex-direction: row; align-items: center; flex-wrap: wrap; }
  nav { flex-direction: row; }
  .me { margin: 0 0 0 auto; }
  .content { padding: 20px 16px; }
}
</style>
